// extracted by mini-css-extract-plugin
export default {"root":"app-react-edge-edge-devices-MTLSCertificateView-MTLSCertificateView-module__root"};